/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: ShMFshqyXXRT
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebWindowManagerSurface from "../../OP1WebWindowManagerSurface"; // plasmic-import: vcRC7TdY5z6b/codeComponent
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: Utk5Dv_x15H2/component
import Op1WebAw from "../../Op1WebAw"; // plasmic-import: 3h2MZU5cY1NW/component
import AwHeaderContent from "../../AwHeaderContent"; // plasmic-import: -30peDirAMTZ/component
import Op1WebDock from "../../Op1WebDock"; // plasmic-import: WsKrqHiP5PVH/component
import Op1WebBgSpaceButton from "../../Op1WebBgSpaceButton"; // plasmic-import: MFZGD62dYS3p/component
import Op1WebButtonAppWindow from "../../OP1WebButtonAppWindow"; // plasmic-import: BXxrqEh84nVD/codeComponent
import Op1WebAwButton from "../../Op1WebAwButton"; // plasmic-import: gNk1RWPoHev5/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebDesktopLayer.module.css"; // plasmic-import: ShMFshqyXXRT/css
import image35HlflJTrr2H0A from "./images/image35.svg"; // plasmic-import: HlflJTrr2H0a/picture
import image73Ej7HXzcFMlt0 from "./images/image73.svg"; // plasmic-import: ej7HXzcFMlt0/picture
import image71B1NDcIvkbWp from "./images/image71.svg"; // plasmic-import: b1n_DcIvkbWP/picture
import image70W1KMuhxRyVis from "./images/image70.svg"; // plasmic-import: W1kMuhxRYVis/picture
import userFocusUhzXeSlJfh4K from "./images/userFocus.svg"; // plasmic-import: uhzXeSlJfh4K/picture
import logo256PxYwIRv7DkmG2 from "./images/logo256Px.svg"; // plasmic-import: ywI_Rv7DkmG2/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicOp1WebDesktopLayer__VariantProps = new Array();

export const PlasmicOp1WebDesktopLayer__ArgProps = new Array();

const $$ = {};

function PlasmicOp1WebDesktopLayer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appWindowButton3.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_nJ1Nn58LcfAm7wemZm71QH",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <Op1WebWindowManagerSurface
          data-plasmic-name={"op1WebWindowManagerSurface"}
          data-plasmic-override={overrides.op1WebWindowManagerSurface}
          className={classNames(
            "__wab_instance",
            sty.op1WebWindowManagerSurface
          )}
        >
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames("all", sty.freeBox)}
          >
            <ButtonPrimary
              className={classNames("__wab_instance", sty.buttonPrimary__e4Haf)}
              color={"supaLight"}
              content={"open page 2"}
              size={"small"}
              ststus={"normal"}
              windowId={"framePilot"}
            />

            <ButtonPrimary
              className={classNames(
                "__wab_instance",
                sty.buttonPrimary___3UkO8
              )}
            />
          </div>
          <Op1WebAw
            className={classNames("__wab_instance", sty.op1WebAw__ind8T)}
            headerSlot={
              <AwHeaderContent
                className={classNames(
                  "__wab_instance",
                  sty.awHeaderContent___9Ed43
                )}
                title={"waitlist"}
                type={"title"}
              />
            }
            isActive={true}
            maximizedHeight={90}
            maximizedWidth={90}
            showBackButton={false}
            showMaximizeButton={false}
            startingHeight={400}
            startingWidth={300}
            startingX={0}
            startingY={0}
            windowIcon={{
              src: image35HlflJTrr2H0A,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
            windowId={"PlasmicWindow"}
          />

          <Op1WebAw
            className={classNames("__wab_instance", sty.op1WebAw___7ZRao)}
            headerSlot={
              <AwHeaderContent
                className={classNames(
                  "__wab_instance",
                  sty.awHeaderContent__eLjqd
                )}
                title={"converstions"}
                type={"titleAndAvatar"}
              />
            }
            maximizedHeight={70}
            maximizedWidth={70}
            showBackButton={false}
            showMaximizeButton={false}
            startingHeight={400}
            startingWidth={400}
            startingX={0}
            startingY={0}
            windowIcon={{
              src: image73Ej7HXzcFMlt0,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
            windowId={"framePilot"}
          />
        </Op1WebWindowManagerSurface>
        <Op1WebDock
          data-plasmic-name={"op1WebDock"}
          data-plasmic-override={overrides.op1WebDock}
          appsWindoesGoHere={
            <React.Fragment>
              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton3"}
                data-plasmic-override={overrides.appWindowButton3}
                className={classNames("__wab_instance", sty.appWindowButton3)}
                icon={userFocusUhzXeSlJfh4K}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"conversations"}
              />

              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton4"}
                data-plasmic-override={overrides.appWindowButton4}
                className={classNames("__wab_instance", sty.appWindowButton4)}
                icon={logo256PxYwIRv7DkmG2}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"framePilot"}
              />

              <Op1WebAwButton
                className={classNames(
                  "__wab_instance",
                  sty.op1WebAwButton___0Xe5J
                )}
                icon={{
                  src: image73Ej7HXzcFMlt0,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                }}
                status={"closed"}
                windowId={"PlasmicWindow"}
              />

              <Op1WebAwButton
                className={classNames(
                  "__wab_instance",
                  sty.op1WebAwButton___5PtBo
                )}
                icon={{
                  src: image35HlflJTrr2H0A,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                }}
                status={"closed"}
                windowId={"framePilot"}
              />
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.op1WebDock)}
          spacesGoHere={
            <React.Fragment>
              <Op1WebBgSpaceButton
                className={classNames(
                  "__wab_instance",
                  sty.op1WebBgSpaceButton__b8Mb8
                )}
                dockButtonIcon={{
                  src: image71B1NDcIvkbWp,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                }}
                pagePath={"/community"}
              />

              <Op1WebBgSpaceButton
                className={classNames(
                  "__wab_instance",
                  sty.op1WebBgSpaceButton___7DiXk
                )}
                dockButtonIcon={{
                  src: image70W1KMuhxRyVis,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                }}
                pagePath={"/community/forum"}
              />
            </React.Fragment>
          }
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "op1WebWindowManagerSurface",
    "freeBox",
    "op1WebDock",
    "appWindowButton3",
    "appWindowButton4"
  ],

  op1WebWindowManagerSurface: ["op1WebWindowManagerSurface", "freeBox"],
  freeBox: ["freeBox"],
  op1WebDock: ["op1WebDock", "appWindowButton3", "appWindowButton4"],
  appWindowButton3: ["appWindowButton3"],
  appWindowButton4: ["appWindowButton4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebDesktopLayer__ArgProps,
          internalVariantPropNames: PlasmicOp1WebDesktopLayer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebDesktopLayer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOp1WebDesktopLayer";
  } else {
    func.displayName = `PlasmicOp1WebDesktopLayer.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicOp1WebDesktopLayer = Object.assign(
  // Top-level PlasmicOp1WebDesktopLayer renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    op1WebWindowManagerSurface: makeNodeComponent("op1WebWindowManagerSurface"),
    freeBox: makeNodeComponent("freeBox"),
    op1WebDock: makeNodeComponent("op1WebDock"),
    appWindowButton3: makeNodeComponent("appWindowButton3"),
    appWindowButton4: makeNodeComponent("appWindowButton4"),
    // Metadata about props expected for PlasmicOp1WebDesktopLayer
    internalVariantProps: PlasmicOp1WebDesktopLayer__VariantProps,
    internalArgProps: PlasmicOp1WebDesktopLayer__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/desktop-layer",
      pagePath: "/desktop-layer",
      params: {},
      query: {}
    })
  }
);

export default PlasmicOp1WebDesktopLayer;
/* prettier-ignore-end */
